import { render } from "./PrintInvoiceContactDetails8cm.vue?vue&type=template&id=587c438a&scoped=true"
import script from "./PrintInvoiceContactDetails8cm.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceContactDetails8cm.vue?vue&type=script&lang=js"

import "./PrintInvoiceContactDetails8cm.vue?vue&type=style&index=0&id=587c438a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587c438a"]])

export default __exports__